import { Component, OnInit, Input } from '@angular/core';
import * as models from '../../models';

@Component({
    selector: 'dd-app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements OnInit {

  @Input()
  sharedData: models.SharedData;

  constructor(
  ) { }

  ngOnInit() {

  }
}
